<template>
  <div class="the-layout-base">
    <the-header></the-header>
    <div class="app-container">
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
import TheHeader from '@comp/TheHeader'
export default {
  name: 'TheLayoutBase',
  components: {
    TheHeader: TheHeader
  },
  data () {
    return {
    }
  },
  computed: {
  },
  methods: {
  },
  mounted () {
  }
}
</script>

<style lang="scss" scoped>
@import "~@style/_var.scss";
@import "~@style/_theme.scss";
.the-layout-base{
  position: relative;
  width: 100%;
  height: 100%;
  padding-top: 64px;
  ::v-deep .the-header{
    position: absolute;
    left: 0;
    top: 0;
  }
  .app-container{
    position: relative;
    z-index: 1;
    width: 100%;
    height: 100%;
  }
}
</style>
